import { GraphiQL } from "graphiql";
import { Fetcher, FetcherOpts, FetcherParams } from "@graphiql/toolkit";
import React from "react";
import "graphiql/graphiql.min.css";
import icon from "../icon.svg";

const generateErrorJson = (message: string) => {
  return {
    errors: [
      {
        message,
        extensions: {
          code: "GRAPHIQL_ERROR",
        },
      },
    ],
  };
};

const defaultQueryText = "# Amplience GraphQL Content Delivery API\n";

const getGraphQlUrl = () =>
  process.env.REACT_APP_URL_ORIGIN !== undefined
    ? `${process.env.REACT_APP_URL_ORIGIN}/graphql`
    : `${window.location.origin}/graphql`;

const customFetcher: Fetcher = async (
  graphQLParams: FetcherParams,
  fetcherOpts?: FetcherOpts
) => {
  // TODO decide .catch error format
  return await fetch(getGraphQlUrl(), {
    method: "POST",
    body: JSON.stringify(graphQLParams),
    headers: {
      "content-type": "application/json",
      ...fetcherOpts?.headers,
    },
    credentials: "same-origin",
  })
    .then((data) => {
      return data
        .json()
        .catch(() => generateErrorJson("Failed to parse response."));
    })
    .catch(() => generateErrorJson("Failed to make request."));
};
const Playground = () => (
  <GraphiQL fetcher={customFetcher} defaultQuery={defaultQueryText}>
    <GraphiQL.Logo>
      <img src={icon} width={35} height={35} style={{ display: "grid" }} />
    </GraphiQL.Logo>
  </GraphiQL>
);

export default Playground;
